var _module = require('../module');

require('../../services/fullscreen-loading');
require('../../services/user');
require('../../services/activate-device-modal');
require('../../services/error-modal');
require('../../services/numbers-only');

_module.component('login', {
    bindings: {
        onActivationExpired: '&',
        onWaitingForActivation: '&',
        autosubmit: '@',
        email: '@',
        phone: '@'
    },
    controllerAs: 'loginCtrl',
    controller: [
        '$log',
        '$fsloading',
        '$user',
        '$activateDeviceModal',
        '$errorModal',
        '$timeout',

        function loginCtrl($log, $fsloading, $user, $activateDeviceModal, $errorModal, $timeout) {
            $log.debug('Login Component');

            var _this = this;

            _this.loginFormData = {};

            if(this.phone) {
                _this.loginFormData.phone = this.phone;
            }

            if(this.email) {
                _this.loginFormData.email = this.email;
            }

            if(_this.autosubmit == 'true' && (_this.loginFormData.phone || _this.loginFormData.email)) {
                $timeout(login, 500);
            }

            // Ctrl Functions
            this.login = login;

            // Functions
            function login() {
                $log.debug('login', _this.loginForm);

                if(!(_this.loginFormData.phone || _this.loginFormData.email)) {
                    return $errorModal('Please enter a phone number or email address');
                }

                var type = _this.loginFormData.phone ? 'phone' : 'email';
                var value = _this.loginFormData[type];

                $fsloading.show();

                $user.login(type, value)
                .then(function onLoginResponse() {
                    _this.onWaitingForActivation();

                    $activateDeviceModal()
                        .result
                        .catch(function onReject() {
                            _this.onActivationExpired();
                        });
                })
                .catch(function onLoginError(err) {
                    $log.error(err);

                    try {
                        var errorMsg = err.data.errors[0].detail;
                    } catch(err) {
                        errorMsg = err.data;
                    }

                    $errorModal(errorMsg);
                })
                .finally(function onFinally() {
                    $fsloading.hide();
                });

            }
        }
    ],
    template: require('./index.html')
});
